export default class Footer {
    constructor() {
        this.footer = document.querySelector('footer');
        this.init();
    }

    init() {
        if (!this.footer) return;
        
        this.setupZoomDetection();
        this.setupGoToTopButton();
    }

    setupGoToTopButton() {
        const goToTopButton = this.footer.querySelector('.btnGoToTop');
        
        if (goToTopButton) {
            goToTopButton.addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
        }
    }

    setupZoomDetection() {
        const checkLayoutFooterConditions400 = () => {
            const screenWidth = window.innerWidth;
            const zoomLevel = Math.round((window.outerWidth / window.innerWidth) * 100);
            
            const needsLayoutChanges400 = screenWidth <= 1280 && zoomLevel > 300;
            
            this.handleZoomFooter400Changes(needsLayoutChanges400);
        };

        checkLayoutFooterConditions400();
        window.addEventListener('resize', checkLayoutFooterConditions400);
    }

    handleZoomFooter400Changes(needsLayoutChanges400) {
     
        // Ajustar grid dos links sociais
        const socialUl = this.footer.querySelector('.social ul');
        if (socialUl) {
            if (needsLayoutChanges400) {
                socialUl.style.gridTemplateColumns = 'repeat(4, minmax(0, 1fr))';
            } else {
                socialUl.style.gridTemplateColumns = '';
            }
        }
        
    }
}

// Inicializa quando o DOM estiver pronto
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new Footer();
    });
} else {
    new Footer();
}
